export enum CoinHistoryTypeEnum {
  ALL = 'ALL',
  PURCHASE = 'PURCHASE',
  REFILL = 'REFILL',
}
